import { api } from './client'
import type {
  BulkPublishResult,
  BulkReviewResult,
  Paged,
  QuestionCoverageRes,
  QuestionDetail,
  QuestionQuery,
  QuestionRow,
  TransitionAction,
} from './types'

export const questionApi = {
  list: (q: QuestionQuery) => api.get<Paged<QuestionRow>>('/admin/questions', q),
  coverage: () => api.get<QuestionCoverageRes>('/admin/questions/coverage'),
  detail: (id: string) => api.get<QuestionDetail>(`/admin/questions/${id}`),
  update: (id: string, patch: Partial<QuestionRow>) =>
    api.patch<{ question: QuestionRow; demoted: boolean }>(`/admin/questions/${id}`, patch),
  transition: (id: string, action: TransitionAction, comment?: string) =>
    api.post<QuestionRow>(`/admin/questions/${id}/transition`, { action, comment }),
  bulkReview: (ids: string[], comment?: string) =>
    api.post<BulkReviewResult>('/admin/questions/bulk-review', { ids, comment }),
  bulkPublish: (ids: string[], comment?: string) =>
    api.post<BulkPublishResult>('/admin/questions/bulk-publish', { ids, comment }),
}
